<ng-container *ngIf="item && item.visible">
    <div style="display: flex; flex: 1;" [ngStyle]="{'height': child ? '33px': 'auto','flex-direction': item.labelPosition && (item.labelPosition == 'left' || item.labelPosition == 'right') ? 'row' : 'column'}">
        <label *ngIf="item.label && (!item.labelPosition || item.labelPosition != 'right') && item.type != 'button'" class="roboSubTitle">{{item.label! | translate}}</label>
        <ng-container  [ngSwitch]="item.type">
            <!-- TEXT -->
            <div *ngSwitchCase="'text'">
                <input type="text" class="form-control" [ngbTooltip]="item.tooltip ? (item.tooltip | translate) : ''" [placeholder]="item.placeholder ? (item.placeholder! | translate) : ''" [(ngModel)]="item.value" (ngModelChange)="notifyChange()">
            </div>
            <!-- NUMBER -->
            <div *ngSwitchCase="'number'">
                <input type="number" class="form-control" [ngbTooltip]="item.tooltip ? (item.tooltip | translate) : ''" [placeholder]="item.placeholder ? (item.placeholder! | translate) : ''" [(ngModel)]="item.value" (ngModelChange)="notifyChange()">
            </div>
            <!-- FLLOAT -->
            <div *ngSwitchCase="'float'">
                <input type="text" smart-float class="form-control" [ngbTooltip]="item.tooltip ? (item.tooltip | translate) : ''" [placeholder]="item.placeholder ? (item.placeholder! | translate) : ''" [(ngModel)]="item.value" (ngModelChange)="notifyChange()">
            </div>
            <!-- SELECT -->
            <div *ngSwitchCase="'select'">
                <app-select class="selectDm7" 
                    [options]="getSelectValues(item)"
                    [key]="'key'" [value]="'value'"
                    [selectedKey]="selected_more"
                    [placeholder]="item.placeholder ? (item.placeholder! | translate) : ''" [addNull]="false"
                    (change)="item.value = $event.key;notifyChange();"></app-select>
            </div>
            <!-- MULTISELECT -->
            <div *ngSwitchCase="'multi_select'">
                <app-multi-select [items]="getMultiSelectValues(item)" (selectedItems)="onSelectChange($event); notifyChange();"></app-multi-select>
            </div>
            <!-- CHECKBOX -->
            <div *ngSwitchCase="'checkbox'">
                <div class="col-1 mb-3 form-check" [ngClass]="{'check_child' : child}">
                    <input type="checkbox" class="form-check-input" style="margin: 0;"  [ngbTooltip]="item.tooltip ? item.tooltip: null"  [(ngModel)]="item.value" 
                    (ngModelChange)="notifyChange();">
                    <!-- (ngModelChange)="notify(item.id)" -->
                </div>
            </div>
            <!-- DATE PICKER [navigation]="'arrows'" readonly -->
            <div *ngSwitchCase="'date_picker'">
                <div class="input-group dm7DatePicker">
                    <input class="form-control"
                            name="d1" #c2="ngModel" [(ngModel)]="item.value" 
                            
                            ngbDatepicker #d1="ngbDatepicker"
                            [ngbTooltip]="item.tooltip ? item.tooltip: null"
                            [placeholder]="item.placeholder ? (item.placeholder! | translate) : ''"
                            value=""  (ngModelChange)="notifyChange()">
                    <button class="btn btn-outline-secondary calendar" style=" border-radius: 0 !important; background-color: var(--bgColor) !important;"
                        (click)="item.value = '';notifyChange();" type="button">
                        <i class="bi bi-x-lg"></i>
                    </button>
                    <button class="btn btn-outline-secondary calendar" (click)="d1.toggle()" type="button">
                        <i class="bi bi-calendar-week"></i>
                    </button>
                </div>
            </div>
            <!-- BUTTON -->
            <div *ngSwitchCase="'button'">
                <button *ngIf="item.id=='btnSearch'"  class="btn btn-success btnAr4m" [ngbTooltip]="item.tooltip ? item.tooltip: null" style="height: 33px; padding-left: 10px; padding-right: 10px;" (click)="notifyChange();">
                    <i *ngIf="item.id=='btnSearch'" class="bi bi-search mr-2 btnAr4m"></i>{{item.label!| translate}}</button>
                <button *ngIf="item.id!='btnSearch'" [ngbTooltip]="item.tooltip ? item.tooltip: null" style="height: 33px; padding-left: 10px; padding-right: 10px; background-color: #8553B6;" (click)="notifyChange();">{{item.label!| translate}}</button>
            </div>
            <!-- BREAK -->
            <div *ngSwitchCase="'break'">
                <div class="break" style="background-color: red; height: 10px;"></div>
            </div>


            <!-- SELECT_MORE -->
            <div *ngSwitchCase="'select_more'" style="display: flex; flex-direction: row; align-items: end;" class="selectDm7Multi">
                <app-select class="selectDm7" 
                    [ngbTooltip]="item.tooltip ? (item.tooltip | translate) : ''"
                    [options]="getSelect_MoreValues(item)"
                    [key]="'key'" [value]="'value'"
                    [selectedKey]="selected_more"
                    [placeholder]="item.placeholder ? (item.placeholder! | translate) : ''" [addNull]="false"
                    (change)="selected_more = $event.key; item.value = selected_more; notifyChange();"></app-select>
                <ng-container *ngIf="selected_more">
                    <ng-container *ngFor="let i of getChildSelect_MoreValues(item); let n = index;">
                        <app-item [item]="i" [child]="true" [ngClass]="{'last' : n == getChildSelect_MoreValues(item).length -1}" (modelChange)="notifyChange()"></app-item>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
        <label *ngIf="item.label && (item.labelPosition && item.labelPosition == 'right') && item.type != 'button'" class="roboSubTitle">{{item.label! | translate}}</label>
    </div>

</ng-container>